import { prop } from 'ramda';
import React, { memo } from 'react';
import { Icon } from '@core/js/components/common/Icon';
import { Jackpot } from '@core/js/components/common/Jackpot';
import { useJackpotsSelector } from '@core/js/store/hooks/useJackpotsSelector';
import { usePortletTranslations } from '@core/js/components/system/Portlet';

import * as Types from '@core/js/components/main/GamesGrid/components/Game/components/GameJackpot/types';

import style from './GameJackpot.scss';

export const GameJackpotBare: React.FC<Types.IGameJackpotProps> = ({ game, className = '', isHitTimeEnabled = false }) => {
    const t = usePortletTranslations();
    const jackpots = useJackpotsSelector(prop('jackpots'));
    const { betDependent } = jackpots[game.jackpotCode] || {};

    if (!game.jackpotCode || !jackpots[game.jackpotCode] || !jackpots[game.jackpotCode]?.amount) {
        return null;
    }

    return (
        <span className={`${style.jackpot} ${className} cms-games-grid-game-jackpot`}>
            <span className={`${style.title}`}>{t('playtech.mobile.system.jackpot')}</span>{/* Lugano changes */}
            <Jackpot enableHitTime={isHitTimeEnabled} code={game.jackpotCode} />
            {betDependent && <Icon type="gamesJackpotLimitsInfo" className={style.infoIcon} />}
        </span>
    );
};

export const GameJackpot = memo(GameJackpotBare);
